export const languages = {
  EN: 'English',
  FR: 'French',
  DE: 'German',
  ZH: 'Chinese (zh)',
};
